import Switch from '@carvana/showroom-forms/Switch';
import { useContext } from 'react';
import AnchorButton from '~/components/common/AnchorButton';
import ModalContext from '~/context/vdp/ModalContext';
import { Title, Wrapper } from './CoApplicant.styles';
import useGetCoApplicant from '../../../hooks/selectors/useGetCoApplicant';
import useGetCoApplicantLoading from '../../../hooks/selectors/useGetCoApplicantLoading';
import SptPriceDetailsContext from '../../../SptPriceDetailsContext';

const WithCoApplicant = () => {
  const { isCoApplicantApplied, setCoApplicantApplied } = useContext(
    SptPriceDetailsContext
  );
  const { setEditCoApplicantModalOpen } = useContext(ModalContext);
  const coApplicant = useGetCoApplicant();
  const isLoading = useGetCoApplicantLoading();

  return (
    <Wrapper data-qa="with-co-applicant">
      <Title>Co-signer</Title>
      <div className="flex w-full items-center justify-between gap-16 m:w-fit">
        <div className="capitalize text-blue-6 tl-body-m">
          {coApplicant.toLowerCase()}
        </div>
        <AnchorButton
          className="tl-link-s"
          data-analytics-id="Price Details - Edit Co-Signer"
          onClick={() => setEditCoApplicantModalOpen(true)}
        >
          Edit
        </AnchorButton>
      </div>
      <div className="w-full border-t border-grey-2" />
      <div className="flex w-full items-center justify-between">
        <label htmlFor="toggle-co-applicant" className="text-blue-6 tl-body-m">
          See terms with co-signer
        </label>
        <Switch
          id="toggle-co-applicant"
          checked={isCoApplicantApplied}
          onChange={() => setCoApplicantApplied(v => !v)}
          disabled={isLoading}
        />
      </div>
    </Wrapper>
  );
};

export default WithCoApplicant;
